import { Record } from 'immutable';

const LookupContactRecord = Record({
  firstName: null,
  lastName: null,
  email: null,
  phone: null,
  fax: null
});

export class LookupContact extends LookupContactRecord {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  fax: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/lookup-contact.ts